module.exports = __webpack_public_path__ + "static/img/help_05intro_02.02b13c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stufdback/help_05intro_02.png
// module id = 721
// module chunks = 140